/**
 * Utility functions for device detection and responsive behavior
 */

/**
 * Detects if the current device is mobile based on user agent
 */
export const isMobile = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  
  // iOS detection
  const isIOS = /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
  
  // Android detection
  const isAndroid = /android/i.test(userAgent);
  
  // General mobile detection
  const isMobileDevice = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent);
  
  return isIOS || isAndroid || isMobileDevice;
};

/**
 * Detects if the device is specifically iOS
 */
export const isIOS = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
  return /iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream;
};

/**
 * Helper function to get device viewport height considering iOS issues
 */
export const getViewportHeight = (): string => {
  if (typeof window === 'undefined') return '100vh';
  
  if (isIOS()) {
    return '-webkit-fill-available';
  }
  
  return '100vh';
};
